import { jsx as _jsx } from "react/jsx-runtime";
import BaseHeaderDesktopComponent from "segments/desktop/header/layouts/base-header/base-header-desktop/base-header-desktop-component";
import { SIGNUP_BUTTON_TYPE } from "segments/desktop/core-components/button/button-consts";
import { MONDAY_LOGO_SRC, ROOT_LINK } from "/constants/links";
const MAIN_SITE_LOGO_OVERRIDE = {
    url: ROOT_LINK,
    src: MONDAY_LOGO_SRC,
    alt: "monday.com"
};
export default function CrmNavMainHeaderFromBase() {
    return /*#__PURE__*/ _jsx(BaseHeaderDesktopComponent, {
        isSecondaryMenuNeeded: false,
        buttonConfig: {
            buttonType: SIGNUP_BUTTON_TYPE
        },
        overrideClusterLogo: MAIN_SITE_LOGO_OVERRIDE
    });
}
